import React from "react"
import { ApolloConsumer } from "react-apollo"
import gql from "graphql-tag"
import moment from "moment"
import { DEFAULT_IMAGE } from "../../constants"

class RelatedPosts extends React.Component {
  constructor(props) {
    super(props)

    this.initialState = {
      posts: [
        {
          slug: "",
          title: null,
          image: null,
          error: null,
          loading: false,
        },
        {
          slug: "",
          title: null,
          image: null,
          error: null,
          loading: false,
        },
        {
          slug: "",
          title: null,
          image: null,
          error: null,
          loading: false,
        },
        {
          slug: "",
          title: null,
          image: null,
          error: null,
          loading: false,
        },
      ],
    }

    if (this.props.posts) {
      this.initialState.posts = this.initialState.posts.map((post, i) => {
        if (this.props.posts[i]) {
          return {
            ...this.props.posts[i],
            error: null,
            loading: false,
          }
        }
        return post
      })
    }

    this.state = {
      ...this.initialState,
    }

    this.typingTimer
  }

  validate = () => {
    let posts = this.state.posts.filter(
      (post) =>
        !post.loading && !post.error && post.title && post.slug && post.image
    )

    if (posts.length === 0) {
      return false
    }

    return true
  }

  getValue = () => {
    let posts = this.state.posts
      .filter((post) => post.title && post.slug && post.image)
      .map(({ error, loading, ...post }) => post)

    return {
      type: "related-posts",
      props: { posts },
    }
  }

  updateOnePost = (index, updates = {}, cb = () => {}) => {
    this.setState((prevState) => {
      let posts = prevState.posts.map((item, i) => {
        if (i === index) {
          return { ...item, ...updates }
        }
        return item
      })

      return { posts }
    }, cb)
  }

  updatePostSlug = (i) => (e) => {
    e.persist()
    if (this.state.posts[i].loading) {
      return
    }

    clearTimeout(this.typingTimer)
    this.updateOnePost(i, {
      slug: e.target.value.toLowerCase(),
      title: null,
      image: null,
      error: null,
      loading: false,
    })
    this.typingTimer = setTimeout(() => this.fetchPostInfo(i), 1000)
  }

  submitPostSlug = (i) => {
    if (this.state.posts[i].loading) {
      return
    }
    clearTimeout(this.typingTimer)
    this.fetchPostInfo(i)
  }

  fetchPostInfo = (i) => {
    let post = this.state.posts[i]
    if (post.loading || !post.slug) {
      return
    }

    this.updateOnePost(i, { loading: true }, () => this.doFetch(i))
  }

  doFetch = async (i) => {
    try {
      let post = this.state.posts[i]
      let { data } = await this.props.fetchPost(post.slug)
      if (!data.post) {
        throw new Error(`No post at ${post.slug}.`)
      }

      let publishDate = new Date(data.post.publishDate).toISOString()

      if (
        !data.post.active ||
        !data.post.publishDate ||
        moment(publishDate).isAfter(moment())
      ) {
        throw new Error("This post has not yet been published.")
      }

      if (!data.post.title) {
        throw new Error("This post has no title.")
      }

      let existingPostIndex = this.state.posts.findIndex(
        (item, idx) =>
          idx !== i && item.slug && data.post.slug.indexOf(item.slug) > -1
      )

      if (existingPostIndex > -1) {
        throw new Error(
          `This post is already in your list of related posts (Post ${
            existingPostIndex + 1
          }).`
        )
      }

      let updates = {
        loading: false,
        error: null,
        title: data.post.title,
        image: data.post.seo.image || DEFAULT_IMAGE,
      }

      this.updateOnePost(i, updates)
    } catch (err) {
      console.log(err)

      let message = "Error loading post preview."

      if (err.graphQLErrors && err.graphQLErrors[0]) {
        message = err.graphQLErrors[0].message
      } else if (err.message) {
        message = err.message
      }

      this.updateOnePost(i, { loading: false, error: message })
    }
  }

  _renderPostPreview = (post, i) => {
    if (!post.slug || !post.title || !post.image) {
      let message
      if (post.loading) {
        message = "Loading post preview..."
      } else {
        message = `Post ${i + 1}`
      }

      return (
        <div key={i} className="related-post-item empty">
          {message}
        </div>
      )
    }

    return (
      <div key={i} className="related-post-item">
        <div className="post-image">
          <img src={post.image} />
        </div>
        <div className="post-title">{post.title}</div>
      </div>
    )
  }

  _renderPostInput = (post, i) => {
    return (
      <div key={i} className="post-input-container">
        <div className={`post-input ${post.error ? "error" : ""}`}>
          <label>Post {i + 1} route: </label>
          <input
            placeholder="/articles/... OR /newsletters/..."
            value={post.slug}
            onChange={this.updatePostSlug(i)}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                this.submitPostSlug(i)
              }
            }}
          />
        </div>
        {post.error && <div className="error-message">{post.error}</div>}
      </div>
    )
  }

  render = () => {
    return (
      <div className="related-posts">
        <div className="related-posts-input">
          {this.state.posts.map(this._renderPostInput)}
        </div>
        <div className="related-posts-preview">
          <div className="related-posts-title">You May Also Like:</div>
          <div className="related-posts-list">
            {this.state.posts.map(this._renderPostPreview)}
          </div>
        </div>
      </div>
    )
  }
}

const GetPostQuery = gql`
  query GET_POST($slug: String!) {
    post(slug: $slug) {
      id
      slug
      title
      seo
      active
      publishDate
    }
  }
`

// eslint-disable-next-line react/display-name
const RelatedPostsWithData = React.forwardRef((props, ref) => (
  <ApolloConsumer>
    {(client) => {
      const fetchPost = (slug) => {
        return client.query({
          query: GetPostQuery,
          variables: { slug },
        })
      }

      return <RelatedPosts {...props} fetchPost={fetchPost} ref={ref} />
    }}
  </ApolloConsumer>
))

export default RelatedPostsWithData
